import type { PublicKey } from "@solana/web3.js";

import type { Registrar, Voter } from "./accounts";
import type { VsrClient } from "./vsrClient";

export const tryGetVoter = async (
  voterPk: PublicKey,
  client: Pick<VsrClient, "program">
) => {
  try {
    const voter = await client?.program.account.voter.fetch(voterPk);
    // Lockup Periods types are not compatible
    // Somehow one of the types expects undefined instead of Deposit.Lockup period but it is not possible to create a Deposit without Lockup period
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return voter as Voter;
  } catch (e) {
    return null;
  }
};

export const tryGetRegistrar = async (
  registrarPk: PublicKey,
  client: Pick<VsrClient, "program">
) => {
  try {
    const existingRegistrar = await client.program.account.registrar.fetch(
      registrarPk
    );
    return existingRegistrar as Registrar;
  } catch (e) {
    return null;
  }
};

export const getMintCfgIdx = async (
  registrarPk: PublicKey,
  mintPK: PublicKey,
  client: VsrClient
) => {
  const existingRegistrar = await tryGetRegistrar(registrarPk, client);
  const mintCfgIdx = existingRegistrar?.votingMints.findIndex(
    (x) => x.mint.toBase58() === mintPK.toBase58()
  );
  if (mintCfgIdx === null || mintCfgIdx === -1) {
    throw new Error("mint not configured to use");
  }
  return mintCfgIdx;
};
